import React from 'react';

import { VideoPlayer } from '@components/molecules/VideoPlayer';
import { PrismicNextImage } from '@prismic/components/PrismicNextImage';

import { usePrismicProductPageQuery } from '@prismic/gqlTypes/prismicHooks';

import { ThumbnailsView } from './ThumbnailsView';

import * as S from './styles';
import { IProps } from './types';

export const ProductGallery: React.FC<IProps> = ({ productSlug }: IProps) => {
  const [imageIndex, setImageIndex] = React.useState<number>(0);

  const { data } = usePrismicProductPageQuery({
    variables: {
      productUid: productSlug,
    },
  });
  const { product: prismicProduct } = data || {};

  const images = prismicProduct?.media || [];

  React.useEffect(() => {
    if (imageIndex >= images.length) {
      setImageIndex(0);
    }
  }, [images]);

  return (
    <S.Wrapper>
      <S.Preview>
        {images &&
        images.length > 0 &&
        imageIndex < images.length &&
        images[imageIndex]?.video ? (
          <VideoPlayer {...images[imageIndex]} />
        ) : (
          <PrismicNextImage field={images[imageIndex]?.image} />
        )}
      </S.Preview>
      <ThumbnailsView
        images={images || []}
        imageIndex={imageIndex}
        setImageIndex={setImageIndex}
      />
    </S.Wrapper>
  );
};
